import gql from 'graphql-tag';

export const contactGroupLocations = gql`
	query ContactsGroupedByLocation($locationId: UUID) {
		contactsGroupedByLocation(locationId: $locationId) {
			id
			name
			contacts {
				id
				pk
				firstName
				lastName
				labels {
					name
					id
					color
					pk
				}
				email
				company
				countryCode
				phoneNumber
			}
		}
	}
`;
export const contactsQuery = gql`
	query Contacts($locationId: UUID) {
		contacts(locationId: $locationId) {
			id
			pk
			firstName
			lastName
			labels {
				name
				id
				color
				pk
			}
			email
			company
			countryCode
			phoneNumber
			location {
				id
				name
			}
		}
	}
`;
